import { useState, useEffect } from "react";
import { Button, message, Upload } from "antd";
import type { UploadProps } from "antd";
import { YhBox } from "@/components/YhBox";
import { useLockFn } from "ahooks";
import { invoiceManageService } from "@/views/invoice/manage/InvoiceManageService";
import { IDescription, DescriptionColorEnum } from "@/components/YhBox/Types";
import { getProdBaseRequestUrl, getBaseUploadData, getToken } from "@/utils/constants";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { useNavModel } from "@/model/navModel";
import { useDetailModel } from "../detailModel";
import { billDataModel } from "./billDataModel";
import { BillDataTable } from "./BillDataTable";
import { NoBill } from "../NoBill";
import { BillSearchBox } from "./BillSearchBox";

let uploadSize = 0;

export const BillDataBox = () => {
    const { setNobillVisible, identification, setSelectedDataMate, } = useDetailModel();

    const { addNav } = useNavModel();
    const [loading] = useState<boolean>(false);
    const {
        summaryData,
        invoiceBillExport, invoiceBillExportAttach,
        selectedRowKeys, selectedData,
        uploadDisable, nobillDisable, applyDisable,
        loadPayMethodLabel
    } = billDataModel();

    const openNobill = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            let flag = 0;
            selectedData.forEach(data => {
                if (data.invoiceStatus == 1) {
                    flag++;
                    message.error(data.code + ":已开票不能重复开票！");
                }
            });
            if (flag == 0) {
                setNobillVisible(true);
            }
        }
        else {
            message.error("请选择记录!");
        }
    }

    const apply = useLockFn(async () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            try {
                let billCodes = selectedData.map(e => e.code);
                let insertRet = await invoiceManageService.invoiceApply(billCodes);
                if (insertRet) {
                    message.success("操作成功!");
                    setNobillVisible(false);
                } else {
                    message.error("操作失败!");
                }
            } catch (e) {
                console.log("系统错误" + e);
            }
        }
        else {
            message.error("请选择记录!");
        }
    })

    let uploadDone = 0;
    let md5List: string[] = [];
    const props: UploadProps = {
        name: 'file',
        multiple: true,
        showUploadList: false,
        action: getProdBaseRequestUrl() + '/fsrv/upload_file?Authorization=' + getToken(),
        data: getBaseUploadData(),
        beforeUpload(file, fileList) {
            uploadSize = fileList.length;
            uploadDone = 0;
            md5List = [];
        },
        onChange(info) {
            if (info.file.status === 'done') {
                uploadDone++;
                md5List.push(info.file.response.retData);
            }
            else if (info.file.status === 'error') {
                message.error(`${info.file.name} 文件上传失败`);
            }
            if (uploadDone == uploadSize && md5List.length > 0) {
                //发票识别、上传
                identification(md5List, true, () => {
                    setSelectedDataMate(selectedData)
                    addNav("14-1-2");
                });
            }
        },
    };

    const action = (
        <>
            <div>
                <YhAuth resCode={ResourceAuthEnum.DATA_INVOICE_INVOICING_UPLOAD}>
                    <Upload {...props}>
                        <Button disabled={uploadDisable} className="mr-5" type="link" shape="round" loading={loading} >上传发票</Button>&nbsp;&nbsp;
                    </Upload>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_INVOICE_INVOICING_NOBILL}>
                    <Button
                        disabled={nobillDisable}
                        className="mr-5"
                        type="link"
                        shape="round"
                        onClick={openNobill}
                    >无票收入</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_INVOICE_INVOICING_APPLY}>
                    <Button
                        disabled={applyDisable}
                        className="mr-5"
                        type="link"
                        shape="round"
                        onClick={apply}
                    >无票申请开票</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_INVOICE_INVOICING_EXPORT}>
                    <Button
                        className="mr-5"
                        type="link"
                        shape="round"
                        onClick={invoiceBillExport}
                    >导出</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_INVOICE_INVOICING_EXPORTATTACH}>
                    <Button
                        className="mr-5"
                        type="link"
                        shape="round"
                        onClick={invoiceBillExportAttach}
                    >导出附件</Button>
                </YhAuth >
            </div >
        </>
    );

    const desc: IDescription[] = [
        {
            label: "单据金额",
            value: summaryData?.totalBillAmount?.toFixed(2) ?? 0.00,
            color: (summaryData?.totalBillAmount ?? 0.00) > 0 ? DescriptionColorEnum.red : DescriptionColorEnum.green
        }, {
            label: "已开票金额",
            value: summaryData?.totalInvoiceAmount?.toFixed(2) ?? 0.00,
            color: (summaryData?.totalInvoiceAmount ?? 0.00) > 0 ? DescriptionColorEnum.red : DescriptionColorEnum.green
        }, {
            label: "未开票金额",
            value: summaryData?.totalNotInvoiceAmount?.toFixed(2) ?? 0.00,
            color: (summaryData?.totalNotInvoiceAmount ?? 0.00) > 0 ? DescriptionColorEnum.red : DescriptionColorEnum.green
        },
    ]

    useEffect(() => {
        loadPayMethodLabel();
    }, [])

    return (
        <>
            <BillSearchBox />
            <YhBox title={action} descriptions={desc}>
                <BillDataTable />
            </YhBox>
            <NoBill />
        </>
    )
}
